@for (item of component.items; track $index; let i = $index) {
<button type="button"
        class="block p-b-2 p-b-5-s cursor-pointer"
        [ngClass]="component.title_fs"
        (click)="scrollToIndex(i)">
    {{ i + 1 + '. ' + item.title }}
</button>
}

<div class="p-t p-t-6-s p-b-5 p-b-7-s"
     [ngClass]="component.intro_fs"
     *iCms="'introduction' of component">
</div>

@for (item of component.items; track $index; let i = $index) {
<div class="p-b-5 p-b-7-s">
    <p [ngClass]="[item.content_title_fs || '', item.content_title_color || '']"
       class="p-b-1"
       [attr.id]="uid + 'item_' + i">
        @if (component.show_bottom_numeration) {
        <span>
            {{ i + 1}}.
        </span>
        }
        {{item.title}}
    </p>
    <p [ngClass]="[item.content_color || '', component.content_fs || '']"
       *iCms="'content' of item">
    </p>
</div>
}